/** Sinchronizuota su `:root` — `styles.css` → `--okis-sticky-action-toolbar-height`. */
const inspectionStickyTop = 'var(--okis-sticky-action-toolbar-height)';
/**
 * Klausimyno turinys renderinamas žemiau papildomo „chrome“ (stepperio eilutė + content wrapper vertikalūs tarpai).
 * Jei neskaičiuojame šios dalies, vidinis konteineris tampa per aukštas ir „palenda“ po apačia.
 */
const inspectionQuestionnaireViewportChromeOffset = '7rem';

export declare namespace QuestionnaireStepTokenSections {
	interface Card {
		background: string;
		borderColor: string;
		borderRadius: string;
	}

	interface SidebarCard {
		background: string;
		titleTextColor: string;
		chevronColor: string;
		statusQuestionColor: string;
		progressTrackBackground: string;
	}

	interface SidebarCardSelected {
		background: string;
		titleTextColor: string;
		chevronColor: string;
		statusQuestionColor: string;
		progressTrackBackground: string;
	}

	interface SidebarCardActiveAccent {
		borderLeftColor: string;
	}

	interface CardActive {
		background: string;
		borderColor: string;
	}

	interface Header {
		background: string;
		textColor: string;
		fontWeight: string;
	}

	interface ControlButton {
		textColor: string;
	}

	interface SearchSelect {
		shadow: string;
	}

	interface SearchOverlay {
		background: string;
		borderColor: string;
	}

	interface EmptyState {
		background: string;
		borderColor: string;
		textColor: string;
	}

	interface DashedEmptyState {
		borderColor: string;
		textColor: string;
	}

	interface Divider {
		borderColor: string;
	}

	interface ResultButton {
		borderColor: string;
		background: string;
		textColor: string;
	}

	interface ResultYes {
		borderColor: string;
		background: string;
		textColor: string;
	}

	interface ResultNo {
		borderColor: string;
		background: string;
		textColor: string;
	}

	interface ResultNotChecked {
		borderColor: string;
		background: string;
		textColor: string;
	}

	interface CardState {
		yesBorderColor: string;
		noBorderColor: string;
		notCheckedBorderColor: string;
		noteOnlyBorderColor: string;
	}

	interface QuestionHeader {
		background: string;
		textColor: string;
	}

	interface QuestionNote {
		background: string;
		borderColor: string;
		labelColor: string;
		textColor: string;
		shadow: string;
	}

	interface LockPopover {
		shadow: string;
	}

	interface NotApplicableForm {
		borderColor: string;
		borderRadius: string;
		padding: string;
		sectionGap: string;
		headBackground: string;
		headPadding: string;
		bodyPaddingInline: string;
		bodySectionGap: string;
		fieldsGap: string;
	}

	interface EditorHeader {
		background: string;
		titleTextColor: string;
		paddingBlock: string;
		paddingInline: string;
	}

	interface ToolbarPanel {
		background: string;
		edgeGap: string;
		edgeInset: string;
		sectionGap: string;
	}

	interface FilterBar {
		background: string;
		paddingInline: string;
		paddingBlock: string;
	}

	interface FilterTitle {
		textColor: string;
	}

	interface FilterTag {
		background: string;
		textColor: string;
		activeBackground: string;
		activeTextColor: string;
		borderRadius: string;
	}

	interface FilterCheckbox {
		textColor: string;
		boxBackground: string;
		boxBorderColor: string;
	}

	interface Sticky {
		topOffset: string;
		zIndex: string;
		sidebarMaxHeight: string;
	}

	interface Progress {
		trackBackground: string;
		valueBackground: string;
		valueTextColor: string;
	}

	interface ActivityAccordion {
		headerTitleColor: string;
		headerBorderBottomColor: string;
		headerToggleIconColor: string;
		headerBackground: string;
	}

	interface ActivityPanel {
		background: string;
		labelColor: string;
		activityTitleColor: string;
		activityCodeColor: string;
		goalTextColor: string;
	}
}

export type QuestionnaireStepTokens = {
	contentPaddingInline: string;
	sidebarLayoutColumnGap: string;
	sidebarEmptyGap: string;
	card: QuestionnaireStepTokenSections.Card;
	sidebarCard: QuestionnaireStepTokenSections.SidebarCard;
	sidebarCardSelected: QuestionnaireStepTokenSections.SidebarCardSelected;
	sidebarCardActiveAccent: QuestionnaireStepTokenSections.SidebarCardActiveAccent;
	cardActive: QuestionnaireStepTokenSections.CardActive;
	header: QuestionnaireStepTokenSections.Header;
	mutedTextColor: string;
	primaryTextColor: string;
	controlButton: QuestionnaireStepTokenSections.ControlButton;
	searchSelect: QuestionnaireStepTokenSections.SearchSelect;
	searchOverlay: QuestionnaireStepTokenSections.SearchOverlay;
	emptyState: QuestionnaireStepTokenSections.EmptyState;
	dashedEmptyState: QuestionnaireStepTokenSections.DashedEmptyState;
	divider: QuestionnaireStepTokenSections.Divider;
	resultButton: QuestionnaireStepTokenSections.ResultButton;
	resultYes: QuestionnaireStepTokenSections.ResultYes;
	resultNo: QuestionnaireStepTokenSections.ResultNo;
	resultNotChecked: QuestionnaireStepTokenSections.ResultNotChecked;
	cardState: QuestionnaireStepTokenSections.CardState;
	questionHeader: QuestionnaireStepTokenSections.QuestionHeader;
	questionNote: QuestionnaireStepTokenSections.QuestionNote;
	lockPopover: QuestionnaireStepTokenSections.LockPopover;
	notApplicableForm: QuestionnaireStepTokenSections.NotApplicableForm;
	editorHeader: QuestionnaireStepTokenSections.EditorHeader;
	toolbarPanel: QuestionnaireStepTokenSections.ToolbarPanel;
	filterBar: QuestionnaireStepTokenSections.FilterBar;
	filterTitle: QuestionnaireStepTokenSections.FilterTitle;
	filterTag: QuestionnaireStepTokenSections.FilterTag;
	filterCheckbox: QuestionnaireStepTokenSections.FilterCheckbox;
	sticky: QuestionnaireStepTokenSections.Sticky;
	progress: QuestionnaireStepTokenSections.Progress;
	activityAccordion: QuestionnaireStepTokenSections.ActivityAccordion;
	activityPanel: QuestionnaireStepTokenSections.ActivityPanel;
};

export const card: QuestionnaireStepTokenSections.Card = {
	background: '{content.background}',
	borderColor: '{content.border.color}',
	borderRadius: '{content.border.radius}',
};

/**
 * Nepasirinkta šoninė kortelė — Figma `6059:34469` (VMVT_OKIS): mėlynai pilkas fonas, šviesūs tekstai.
 * Spalvos per `surface.*` (→ `gray.*`), be tikslių hex.
 */
export const sidebarCard: QuestionnaireStepTokenSections.SidebarCard = {
	background: '{surface.300}',
	titleTextColor: '{surface.0}',
	chevronColor: '{surface.0}',
	statusQuestionColor: '{surface.400}',
	progressTrackBackground: '{surface.200}',
};

/**
 * Pasirinkta šoninė kortelė — tamsus fonas (kaip dešinės panelės antraštė `editorHeader`).
 */
export const sidebarCardSelected: QuestionnaireStepTokenSections.SidebarCardSelected = {
	background: '{surface.700}',
	titleTextColor: '{surface.0}',
	chevronColor: '{surface.0}',
	statusQuestionColor: '{surface.400}',
	progressTrackBackground: '{named.questionnaire.selected.progress.track.background}',
};

export const sidebarCardActiveAccent: QuestionnaireStepTokenSections.SidebarCardActiveAccent = {
	borderLeftColor: '{form.field.focus.border.color}',
};

export const cardActive: QuestionnaireStepTokenSections.CardActive = {
	background: '{surface.700}',
	borderColor: '{surface.700}',
};

export const header: QuestionnaireStepTokenSections.Header = {
	background: '{surface.100}',
	textColor: '{text.color}',
	fontWeight: '600',
};

export const controlButton: QuestionnaireStepTokenSections.ControlButton = {
	textColor: '{text.color}',
};

export const searchSelect: QuestionnaireStepTokenSections.SearchSelect = {
	shadow: '0 1px 2px 0 rgba(18, 18, 23, 0.05)',
};

export const searchOverlay: QuestionnaireStepTokenSections.SearchOverlay = {
	background: '{overlay.popover.background}',
	borderColor: '{overlay.popover.border.color}',
};

export const emptyState: QuestionnaireStepTokenSections.EmptyState = {
	background: '{surface.50}',
	borderColor: '{content.border.color}',
	textColor: '{text.muted.color}',
};

export const dashedEmptyState: QuestionnaireStepTokenSections.DashedEmptyState = {
	borderColor: '{surface.300}',
	textColor: '{text.muted.color}',
};

export const divider: QuestionnaireStepTokenSections.Divider = {
	borderColor: '{content.border.color}',
};

export const resultButton: QuestionnaireStepTokenSections.ResultButton = {
	borderColor: '{surface.100}',
	background: '{surface.50}',
	textColor: '{surface.800}',
};

export const resultYes: QuestionnaireStepTokenSections.ResultYes = {
	borderColor: '{green.200}',
	background: '{green.100}',
	textColor: '{green.600}',
};

export const resultNo: QuestionnaireStepTokenSections.ResultNo = {
	borderColor: '{red.100}',
	background: '{red.50}',
	textColor: '{red.500}',
};

export const resultNotChecked: QuestionnaireStepTokenSections.ResultNotChecked = {
	borderColor: '{yellow.100}',
	background: '{yellow.50}',
	textColor: '{yellow.500}',
};

export const cardState: QuestionnaireStepTokenSections.CardState = {
	yesBorderColor: '{green.600}',
	noBorderColor: '{red.500}',
	notCheckedBorderColor: '{yellow.500}',
	noteOnlyBorderColor: '{orange.500}',
};

export const questionHeader: QuestionnaireStepTokenSections.QuestionHeader = {
	background: '{primary.50}',
	textColor: '{primary.500}',
};

export const questionNote: QuestionnaireStepTokenSections.QuestionNote = {
	background: '{orange.50}',
	borderColor: '{orange.100}',
	labelColor: '{orange.500}',
	textColor: '{surface.700}',
	shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
};

/** The question lock popover: a dark tooltip surface. */
export const lockPopover: QuestionnaireStepTokenSections.LockPopover = {
	shadow: '0 4px 4px 0 rgba(2, 5, 10, 0.04)',
};

/** Figma `11617:43460` — questions-form-sections (nepildymo priežastis). */
export const notApplicableForm: QuestionnaireStepTokenSections.NotApplicableForm = {
	borderColor: '{surface.100}',
	borderRadius: '4px',
	padding: '1rem',
	sectionGap: '2rem',
	headBackground: '{surface.0}',
	headPadding: '0.75rem',
	bodyPaddingInline: '1rem',
	bodySectionGap: '2.375rem',
	fieldsGap: '1rem',
};

export const editorHeader: QuestionnaireStepTokenSections.EditorHeader = {
	background: '{surface.700}',
	titleTextColor: '{surface.0}',
	/** Figma: 16px vertical/horizontal padding around the dark editor header. */
	paddingBlock: '1rem',
	paddingInline: '1rem',
};

export const toolbarPanel: QuestionnaireStepTokenSections.ToolbarPanel = {
	background: '{surface.0}',
	/** Figma: 20px vertical padding between the dark editor header and the search row (and the bottom of the filter row). */
	edgeGap: '0rem',
	edgeInset: '1.25rem',
	/** Tarpas tarp paieškos ir filtrų eilučių — sumažintas iki 6px, kad eilutės priglustų arčiau. */
	sectionGap: '0.375rem',
};

export const filterBar: QuestionnaireStepTokenSections.FilterBar = {
	background: '{content.subtle.background}',
	paddingInline: '1rem',
	/** Sumažintas vertikalus padding pilkoje filtrų juostoje — buvo 12px, dabar 6px. */
	paddingBlock: '0.375rem',
};

export const filterTitle: QuestionnaireStepTokenSections.FilterTitle = {
	textColor: '{surface.950}',
};

export const filterTag: QuestionnaireStepTokenSections.FilterTag = {
	background: '{surface.100}',
	textColor: '{surface.960}',
	activeBackground: '{primary.400}',
	activeTextColor: '{surface.0}',
	borderRadius: '0.375rem',
};

export const filterCheckbox: QuestionnaireStepTokenSections.FilterCheckbox = {
	textColor: '{surface.950}',
	boxBackground: '{surface.0}',
	boxBorderColor: '{surface.200}',
};

export const sticky: QuestionnaireStepTokenSections.Sticky = {
	topOffset: inspectionStickyTop,
	zIndex: '28',
	sidebarMaxHeight: `calc(100dvh - ${inspectionStickyTop} - ${inspectionQuestionnaireViewportChromeOffset})`,
};

/** VMVT Figma 4431 — šoninės juostos progreso juosta (pilka segmentas + % tekstas) */
export const progress: QuestionnaireStepTokenSections.Progress = {
	trackBackground: '{surface.200}',
	valueBackground: '{green.400}',
	valueTextColor: '{named.questionnaire.progress.value.color}',
};

/** VMVT Figma 4431 / 6061:21308 — „Veiklai priskirti tikslai“ eilutė */
export const activityAccordion: QuestionnaireStepTokenSections.ActivityAccordion = {
	headerTitleColor: '{primary.400}',
	headerBorderBottomColor: '{primary.200}',
	headerToggleIconColor: '{primary.400}',
	headerBackground: '{surface.0}',
};

/** Tikslų sąrašo fonas šoninėje (be Tailwind spalvų utility) */
export const activityPanel: QuestionnaireStepTokenSections.ActivityPanel = {
	background: '{content.background}',
	labelColor: '{surface.400}',
	activityTitleColor: '{surface.800}',
	activityCodeColor: '{surface.400}',
	goalTextColor: '{surface.800}',
};

export default {
	/** Figma: 24px nuo balto redaktoriaus ploto krašto (kai šalia šoninė juosta). */
	contentPaddingInline: '1.5rem',
	/** Figma: 24px tarpas tarp šoninės juostos ir redaktoriaus. */
	sidebarLayoutColumnGap: '1.5rem',
	/** Figma 14674:30277 — tarpas tarp info toast ir „Pridėti klausimyną“. */
	sidebarEmptyGap: '1.5625rem',
	card,
	sidebarCard,
	sidebarCardSelected,
	sidebarCardActiveAccent,
	cardActive,
	header,
	mutedTextColor: '{text.muted.color}',
	primaryTextColor: '{primary.color}',
	controlButton,
	searchSelect,
	searchOverlay,
	emptyState,
	dashedEmptyState,
	divider,
	resultButton,
	resultYes,
	resultNo,
	resultNotChecked,
	cardState,
	questionHeader,
	questionNote,
	lockPopover,
	notApplicableForm,
	editorHeader,
	toolbarPanel,
	filterBar,
	filterTitle,
	filterTag,
	filterCheckbox,
	sticky,
	progress,
	activityAccordion,
	activityPanel,
} satisfies QuestionnaireStepTokens;
